// Get the header element
const header = document.querySelector('.header-wrapper');

// Get the initial offset of the header
const headerOffset = header.offsetTop;

// Function to check and toggle the sticky class
function toggleStickyHeader() {
    if (window.pageYOffset > headerOffset) {
      header.classList.add('small_sticky_header');
      $('.section-header.shopify-section-group-header-group').css("z-index","8");
    } else {
      header.classList.remove('small_sticky_header');
      $('.section-header.shopify-section-group-header-group').css("z-index","7");
    }
}
// Attach an event listener to the scroll event
window.addEventListener('scroll', toggleStickyHeader);


// Check Window Width For Header Scroll Functionality
$(document).ready(function(){
   if ($(window).width() > 1024) {
      $("body").addClass("desktop_template");
      $("body").removeClass("mobile_template");
   } else {
      $("body").addClass("mobile_template");
      $("body").removeClass("desktop_template");
   }
});
$(window).on('resize',function(){
   if ($(window).width() > 1024) {
      $("body").addClass("desktop_template");
      $("body").removeClass("mobile_template");
   } else {
      $("body").addClass("mobile_template");
      $("body").removeClass("desktop_template");
   }
});